import React from 'react';

export const CheckArrow = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g stroke="#000000" strokeWidth="1.5">
                <polyline points="18 6 10.5037196 18 6 13.5" />
            </g>
        </g>
    </svg>
);
